import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { FunctionField } from 'react-admin';
import { FCRAWorker } from '@/types/turn-api';
import { EditButtonProps } from './types';

const EditButton = ({ source, onEdit }: EditButtonProps) => (
  <FunctionField
    source={source}
    sortable={false}
    render={(record: FCRAWorker.Address) => {
      if (!record) return null;
      return (
        <IconButton aria-label="Edit address" onClick={() => onEdit(record)} size="small">
          <EditIcon fontSize="small" />
        </IconButton>
      );
    }}
  />
);

export default EditButton;
